import api from "../api";
import i18next from "i18next";

const apiService = {
  get(url) {
    return api.get(url, {
      headers: getSimpleHeaders(),
    });
  },
  post(url, body) {
    return api.post(url, body, {
      headers: getSimpleHeaders(),
    });
  },
  delete(url) {
    return api.delete(url, {
      headers: getSimpleHeaders(),
    });
  },

  getFromFile(url) {
    return api.get(url, {
      responseType: "blob",
      headers: getSimpleHeaders(),
    });
  },
};

function getSimpleHeaders() {
  const phpToken = localStorage.getItem("phpToken");
  return {
    "Content-Type": "application/json",
    "Accept-Language": i18next.language,
    Authorization: `${phpToken}`,
  };
}

export default apiService;
